// Extracted from tailwindcss-stimulus-components

import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    component: String
  }

  remove() {
    document.cookie = `${this.componentValue}_widget=true`;
    const chatbotWidgets = document.querySelectorAll('.custom-chatbot-widget');
    chatbotWidgets.forEach(widget => widget.remove());
  }
}
